/* Built In Imports */
import { useRouter } from 'next/router';

/* External Imports */
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  ModalCloseButton,
  Image,
  Text,
} from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';
import { getUtmParamsFromUrl } from '@components/Utility/utils';

/* Internal Imports */
/* Component */
import SimpleButton from '../../components/Buttons/SimpleButton';
import { mixPanel } from '@utils/Mixpanel';
import config from '@config';
import { usePathname } from 'next/navigation';
/* Styles */
/* Services */

/**
 *
 * @param {Object} pageData
 * @param {String} lang
 * @param {String} region
 * @returns {ReactElement} PricingPopup
 */
const WPChatButton = ({ lang, region, isPopup, setIsPopup, pageData }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const pathname = usePathname();
  const isWavesOfBlissUPPage = pathname.includes('wave-of-bliss-uttar-pradesh');

  const [dataJson] = pageData?.pageConfig?.[0]?.value?.chatbot || [{}];

  const {
    title = '',
    button: buttonText = '',
    terms1 = '',
    terms2 = '',
    link = '',
  } = dataJson || {};

  const getLink = link => {
    const url = new URL(link);

    // Append your UTM params
    const utmParams = new URLSearchParams(getUtmParamsFromUrl());
    utmParams.forEach((value, key) => {
      if (!url.searchParams.has(key)) {
        url.searchParams.set(key, value);
      }
    });

    return url.toString();
  };

  const mixPanelEventTrigger = () => {
    const Mixpanel = mixPanel(window?.location.pathname);
    Mixpanel.track('ie_wave_continue_to_chat_click', {
      page_name: 'Whatsapp Bot page',
      element: 'Continue to Chat',
      language: config?.lngList?.[lang],
    });
  };

  return (
    <Drawer
      isOpen={isPopup}
      placement={isMobile ? 'bottom' : 'right'}
      onClose={() => {
        setIsPopup(false);
      }}
      size="full"
    >
      <DrawerOverlay />
      <DrawerContent
        background={'rgba(0, 0, 0, 0.1)'}
        h={{ base: 'auto', md: '100vh' }}
        mt={{ base: 'auto', md: '0' }}
      >
        <DrawerBody
          display="flex"
          justifyContent="center"
          alignItems="center"
          p={{ base: '0px !important' }}
        >
          <Box
            maxW={{ base: '100%', md: '604px' }}
            mx="auto"
            width="100%"
            background="#ffffff"
            pos="relative"
            maxH="100%"
            overflowY="auto"
            px={{ base: '16px', md: '25px' }}
            py={{ base: '21px', md: '16px' }}
            borderRadius={{ base: '24px 24px 0px 0px', md: '12px' }}
          >
            <ModalCloseButton />
            <Flex flexDirection={'column'} mt={{ base: '15px', md: '12px' }}>
              <Image
                src="/assets/images/logo.png"
                alt="Isha Foundation"
                mx="auto"
                h="58px"
              />

              <Text
                fontSize={{ base: '16px', md: '18px' }}
                mb={{ base: '27px', md: '37px' }}
                mt={{ base: '17px', md: '18px' }}
                textAlign={'center'}
                fontFamily={'FedraSansStd-medium'}
                fontWeight={'450'}
                color={'#000000'}
              >
                {title || 'Isha Foundation'}
              </Text>

              <SimpleButton
                id="waves-of-bliss-wa-continue-button"
                minW="181px"
                background={'#128C7E !important'}
                h={{ base: '43px' }}
                minH={{ base: '43px' }}
                textAlign="center"
                mb={'0'}
                mt={'0'}
                mx={{ base: 'auto', md: '0', lg: 'auto' }}
                _hover={{
                  background: '#128C7E !important',
                }}
                borderRadius={'50px !important'}
                style={{
                  buttonStyle: 'Orange',
                  buttonText: buttonText || 'Continue to Chat',
                  linkUrl: getLink(link),
                }}
                onClick={() => {
                  mixPanelEventTrigger();
                }}
                padding={{
                  base: '10px 26px',
                }}
                lineHeight={{
                  base: '23px',
                }}
                color={'#fff'}
                fontSize={{ base: '14px', md: '16px' }}
                zIndex={100}
              />

              <Text
                fontSize="14px"
                mt={{ base: '17px', md: '42px' }}
                color="#566666"
                textAlign={'center'}
                mx={{ base: '40px', md: 'auto' }}
                mb={{ base: '9px', md: '20px' }}
                fontFamily={'FedraSansStd-medium'}
                lineHeight={'16px'}
                fontWeight={'500'}
              >
                {terms1 || 'I have read, understood and agree to the'}{' '}
                <Box
                  as="a"
                  href={`${config.BASE_PATH}/in/en/copyright-privacy-policy-terms#privacy`}
                  textDecorationLine="underline"
                  target="_blank"
                >
                  {terms2 || 'Privacy Policy'}
                </Box>{' '}
              </Text>
            </Flex>
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default WPChatButton;
